import React from 'react'
import { Checkbox, ControlLabel } from 'gu-ui-kit'

const renderCheckbox = ({
  input,
  meta: { touched, submitting, error } = {},
  ...rest
}) => {
  return (
    <ControlLabel
      {...input}
      {...rest}
      checked={rest.checked}
      label={rest.label}
      error={touched && error}
      onChange={(event) => input.onChange(!!event.currentTarget.checked)}
      hidden={!!rest.hidden || rest.type === 'hidden'}
      disabled={submitting || rest.disabled}
      control={<Checkbox />}
    />
  )
}

export default renderCheckbox
